// src / domain / constants / roles.ts

export const ROLES = {
  CPU_ADMIN: 'CPU_Admin',
  CPU_ADMIN_RESEAU: 'CPU_Admin_réseau',
  CPU_ADMINS_CLIENTS: 'CPU_admins_clients',
  CPU_ADMIN_INTERNE: 'CPU_admin_interne',
  CPU_CHARGE_PROJETS: 'CPU_Chargé_projets',
  CPU_LOGISTIQUE: 'CPU_Logistique',
  CPU_REP_CA: 'CPU_rep_ca',
  CPU_SUPPORT_NIV_1_2_3: 'CPU_Support_Niv_1_2_3',
  CPU_TECHN_ROUTE: 'CPU_Techn_route',
  CPU_TECH: 'CPU_tech',
  DEVOPS: 'devops',
  CPU_SPEC_RESEAU: 'CPU_Spéc_Réseau',
  CPU_TECHN_ROUTE_SB: 'CPU_Techn_route_SB'
} as const

export type Role = typeof ROLES[keyof typeof ROLES]
